import styled from "styled-components";
import { Apple, Facebook, Google, OriginalTelegram } from "common/Icons/Icons";
import { OAuthPlatformType } from "@shared/types";
import Divider from "common/misc/Divider";
import useSocialLogins from "@shared/features/onboarding/hooks/useSocialLogins";
import { MessageType } from "@shared/services/webview/types.ts";
import { generateWebViewMessageId } from "@shared/services/webview/utils.ts";
import { postMessageToNative } from "services/webview/webViewBridgeUtils.ts";
import { IS_WEB_VIEW } from "common/constants.ts";
import { useSelector } from "react-redux";
import { selectIsDarkMode } from "@shared/slices/common.slice.ts";
import useTelegramLogin from "features/auth/useTelegramLogin.ts";

interface SocialLoginsProps {
  isRegister?: boolean;
}

const SocialLogins = ({ isRegister }: SocialLoginsProps) => {
  const isDarkMode = useSelector(selectIsDarkMode);

  const { onLoginClick } = useSocialLogins({
    openUrl: (url) => {
      if (IS_WEB_VIEW) {
        postMessageToNative({
          id: generateWebViewMessageId(),
          type: MessageType.OPEN_AUTH_SESSION,
          payload: { pathname: url },
        });
      } else {
        window.open(url, "_self");
      }
    },
  });
  useTelegramLogin();

  const getIconStyle = (size: number, oauthPlatform?: OAuthPlatformType) => {
    const iconFilters =
      oauthPlatform === OAuthPlatformType.APPLE && isDarkMode
        ? { filter: "invert(100%)" }
        : undefined;
    return { width: size, height: size, ...iconFilters };
  };

  const getIcon = (oauthPlatform: OAuthPlatformType) => {
    const Icon = OAUTH_TYPE_TO_ICON[oauthPlatform];
    return <Icon style={getIconStyle(ICON_SIZE, oauthPlatform)} />;
  };

  const getButton = (oauthPlatform: OAuthPlatformType) => {
    const icon = getIcon(oauthPlatform);
    return <Button onClick={() => onLoginClick(oauthPlatform)}>{icon}</Button>;
  };

  return (
    <>
      <Divider
        text={`Or ${isRegister ? "register" : "login"} with`}
        style={{ margin: "20px 0 16px 0" }}
      />
      <Wrapper>
        {getButton(OAuthPlatformType.GOOGLE)}
        {getButton(OAuthPlatformType.APPLE)}
        {getButton(OAuthPlatformType.TELEGRAM)}
      </Wrapper>
    </>
  );
};

export default SocialLogins;

const ICON_SIZE = 24;

const OAUTH_TYPE_TO_ICON = {
  [OAuthPlatformType.GOOGLE]: Google,
  [OAuthPlatformType.APPLE]: Apple,
  [OAuthPlatformType.FACEBOOK]: Facebook,
  [OAuthPlatformType.TELEGRAM]: OriginalTelegram,
};

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  column-gap: 12px;
`;
const Button = styled.div`
  border-radius: 8px;
  cursor: pointer;
  background-color: ${(p) => p.theme.colors.tagBgColor};
  padding: 10px;
  display: flex;
  align-items: center;
`;
